import { getToken } from "@/utils/auth";
import { notEmpty } from "@/utils/type";
import Vue from "vue";
import Vuex from "vuex";
// import supplyDemand from '@/store/modules/supplyDemand'
// import saasApp from '@/store/modules/saasApp'
// import expert from '@/store/modules/expert'
// import policyRelevant from '@/store/modules/policyRelevant'
// import news from '@/store/modules/news'
// import financialService from '@/store/modules/financialService'
// import trainingPractice from '@/store/modules/trainingPractice'
// import successCases from '@/store/modules/successCases'
// import scientificResults from '@/store/modules/scientificResults'
// import skillsCompetition from '@/store/modules/skillsCompetition'
// import certificationTesting from '@/store/modules/certificationTesting'
// import cloudResource from '@/store/modules/cloudResource'
// import enterprises from '@/store/modules/enterprises'
// import universities from '@/store/modules/universities'
// import researchInstitutes from '@/store/modules/researchInstitutes'
// import caseDeclaration from '@/store/modules/caseDeclaration'
// import solution from '@/store/modules/solution'
// import lectureHall from '@/store/modules/lectureHall'
// import organizationModule from '@/store/modules/organizationModule'
const modulesFiles = require.context("./modules", true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showPhoneDialog: false,
    showPasswordDialog: false,
    showAccountDialog: false,
    payPageWindow: null,
    zfbPaySuccess: false,
    wxPaySuccess: false,
    wxOrderData: null,
  },
  getters: {
    sidebar: state => state.app.sidebar,
    account: state => state.user.account,
    name: state => state.user.name,
    token: state => {
      return state.user.token || getToken();
    },
  },
  mutations: {
    SET_PHONE_DIALOG(state, show) {
      console.log("SET_PHONE_DIALOG", show);
      state.showPhoneDialog = show;
    },
    SET_PASSWORD_DIALOG(state, show) {
      console.log("SET_PASSWORD_DIALOG", show);
      state.showPasswordDialog = show;
    },
    SET_ACCOUNT_DIALOG(state, show) {
      console.log("SET_ACCOUNT_DIALOG", show);
      state.showAccountDialog = show;
    },
    OPEN_PAY_PAGE(state, formStr) {
      localStorage.setItem("zfbPayForm", formStr);
      state.payPageWindow = window.open(location.origin + "/#/payPage");
    },
    CLOSE_PAY_PAGE(state) {
      if (state.payPageWindow) {
        state.payPageWindow.close();
      }
    },
    SET_ZFB_PAY_SUCCESS(state, success) {
      state.zfbPaySuccess = success;
    },
    SET_WX_PAY_SUCCESS(state, success) {
      // console.log("SET_WX_PAY_SUCCESS", success);
      state.wxPaySuccess = success;
    },
    SET_WX_ORDER_DATA(state, data) {
      if (notEmpty(data)) {
        state.wxOrderData = data;
      } else {
        state.wxOrderData = null;
      }
    },
  },
  actions: {},
  modules,
});
